import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromBatteryReplacement from './reducers/battery-replacement.reducer';
import {BatteryReplacementEffects} from './effects/battery-replacement.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('batteryReplacement', fromBatteryReplacement.reducer),
    EffectsModule.forFeature([BatteryReplacementEffects])
  ]
})
export class BatteryReplacementModule { }
